/* eslint-disable */
// @ts-nocheck
 
 
 
 
 
/* eslint-disable padding-line-between-statements, spaced-comment */
 
 
 
 
 
 
 
/* eslint-disable no-nested-ternary */
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

/**
 * Generate a Settlement PDF with selectable text using jsPDF.
 * This creates a text-based PDF where users can copy and select text.
 * 
 * @param {Object} settlementData - Settlement data object
 * @param {Object} intl - Internationalization object for translations
 * @returns {Promise<void>} Promise that resolves when PDF is downloaded
 */
export const generateSettlementTextPDF = async (settlementData, intl) => {
  try {
    // Detect if we're using Arabic language
    const isArabic = intl && intl.locale && intl.locale.includes('ar');

    // For Arabic language, fall back to HTML-based PDF generation which supports Arabic properly
    if (isArabic) {
      console.log('Arabic language detected, falling back to HTML-based PDF generation for proper Arabic support');

      // Import the original PDF generator for Arabic support
      const { generateSettlementPDF } = await import('./pdfGenerator');
      return await generateSettlementPDF(settlementData, intl);
    }

    // For English and other languages, use jsPDF for selectable text
    const doc = new jsPDF('p', 'mm', 'a4');
    doc.setFont('helvetica');

    // Helper function to format dates as dd-mm-yyyy
    const formatDate = (dateString) => {
      if (!dateString) return '-';

      let date;
      // Handle different date formats
      if (typeof dateString === 'string') {
        // If it's an ISO string or standard format, use it directly
        if (dateString.includes('T') || dateString.includes('-')) {
          date = new Date(dateString);
        } else {
          // If it's in MM/DD/YYYY format, convert to proper format
          const parts = dateString.split('/');
          if (parts.length === 3) {
            // Assume MM/DD/YYYY and convert to YYYY-MM-DD
            date = new Date(`${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`);
          } else {
            date = new Date(dateString);
          }
        }
      } else {
        date = new Date(dateString);
      }

      // Check if the date is valid
      if (isNaN(date.getTime())) return '-';

      console.log('Original date string:', dateString);
      console.log('Parsed date object:', date);
      console.log('getDate():', date.getDate());
      console.log('getMonth():', date.getMonth());
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      console.log('Formatted result:', `${day}-${month}-${year}`);
      return `${day}-${month}-${year}`;
    };

    // Helper function to format financial values
    const formatAmount5 = (value) => {
      return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 5, maximumFractionDigits: 5 });
    };
    const formatAmount2 = (value) => {
      return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // Helper function to translate account names
    const getAccountName = (accountName) => {
      if (!intl) return accountName;

      const accountMappings = {
        'Unsettled Dues (11200)': intl.formatMessage({ id: 'settlement_UnsettledDues' }),
        'Bank Account (10100)': intl.formatMessage({ id: 'settlement_BankAccountAssetName' }),
        'Commission Income (40100)': intl.formatMessage({ id: 'settlement_CommissionIncomeAccount' }),
        'VAT Payable (20300)': intl.formatMessage({ id: 'settlement_VATPayableAccount' }),
        'Operating Account (10100)': intl.formatMessage({ id: 'settlement_OperatingAccountName' }),
        'Fare Revenue (40100)': intl.formatMessage({ id: 'settlement_FareRevenueAccount' }),
        'Commission Expense (50100)': intl.formatMessage({ id: 'settlement_CommissionExpenseAccount' }),
        'VAT Receivable (10200)': intl.formatMessage({ id: 'settlement_VATReceivableAccount' }),
        'Unsettled Dues': intl.formatMessage({ id: 'settlement_UnsettledDues' }),
        'Bank Account': intl.formatMessage({ id: 'settlement_BankAccountAssetName' }),
        'Commission Income': intl.formatMessage({ id: 'settlement_CommissionIncomeAccount' }),
        'VAT Payable': intl.formatMessage({ id: 'settlement_VATPayableAccount' }),
        'Operating Account': intl.formatMessage({ id: 'settlement_OperatingAccountName' }),
        'Fare Revenue': intl.formatMessage({ id: 'settlement_FareRevenueAccount' }),
        'Commission Expense': intl.formatMessage({ id: 'settlement_CommissionExpenseAccount' }),
        'VAT Receivable': intl.formatMessage({ id: 'settlement_VATReceivableAccount' })
      };

      return accountMappings[accountName] || accountName;
    };

    // Helper function to translate status values
    const getTranslatedStatus = (status) => {
      if (!intl) return status;

      const statusTranslations = {
        'Draft': intl.formatMessage({ id: 'settlement_StatusDraft' }),
        'Confirmed': intl.formatMessage({ id: 'settlement_StatusConfirmed' }),
        'Cleared': intl.formatMessage({ id: 'settlement_StatusCleared' }),
        'Reversed': intl.formatMessage({ id: 'settlement_StatusReversed' }),
        'Pending': intl.formatMessage({ id: 'settlement_StatusPending' })
      };

      return statusTranslations[status] || status;
    };

    // Set font
    doc.setFont('helvetica');

    let yPosition = 10;
    const pageWidth = doc.internal.pageSize.width;
    const margin = 5;
    const contentWidth = pageWidth - (margin * 2);

    // Header
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    const headerText = intl ? intl.formatMessage({ id: 'settlement_SettlementReport' }) : 'Settlement Report';
    doc.text(headerText, pageWidth / 2, yPosition, { align: 'center' });

    yPosition += 6;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`${settlementData.id}`, pageWidth / 2, yPosition, { align: 'center' });

    yPosition += 4;

    // Created Date Section (for Confirmed, Cleared, Reversed statuses)
    if (['Confirmed', 'Cleared', 'Reversed'].includes(settlementData.status) && settlementData.created_at) {
      doc.setFontSize(8);
      const createdText = `${intl ? intl.formatMessage({ id: 'settlement_CreatedAt' }) : 'Created At'}: ${formatDate(settlementData.created_at)}`;
      doc.text(createdText, pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 5;
    }

    // Status (if not Cleared)
    yPosition += -6; //-6px margin top
    if (settlementData.status !== 'Cleared') {
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      const statusText = `${intl ? intl.formatMessage({ id: 'settlement_StatusLabel' }) : 'Status'}: ${getTranslatedStatus(settlementData.status)}`;
      doc.text(statusText, margin, yPosition);
      yPosition += 5;
    }

    // Reversal Reason Section (for Reversed status)
    if (settlementData.status === 'Reversed' && settlementData.reversal_reason) {
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      const reversalText = `${intl ? intl.formatMessage({ id: 'settlement_ReversalReason' }) : 'Reversal Reason'}: ${settlementData.reversal_reason}`;
      doc.text(reversalText, margin, yPosition);
      yPosition += 5;

      if (settlementData.reversed_at) {
        const reversedAtText = `${intl ? intl.formatMessage({ id: 'settlement_ReversedAt' }) : 'Reversed At'}: ${formatDate(settlementData.reversed_at)}`;
        doc.text(reversedAtText, margin, yPosition);
        yPosition += 0;
      }
    }

    // Draw line under header
    yPosition += 3;
    doc.setLineWidth(0.2);
    doc.line(margin, yPosition, pageWidth - margin, yPosition);
    yPosition += 5;

    // Period Section
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    const periodText = `${intl ? intl.formatMessage({ id: 'settlement_From' }) : 'From'}: ${settlementData.fromDate || '-'} ${intl ? intl.formatMessage({ id: 'settlement_To' }) : 'To'}: ${settlementData.toDate || '-'}`;
    doc.text(periodText, margin, yPosition);
    yPosition += 3; // 5px margin bottom

    // Parties & Banks Section - Two column layout with boxes
    const boxHeight = 28;
    const boxWidth = (contentWidth - 4) / 2; // 10mm gap between boxes
    const leftBoxX = margin;
    const rightBoxX = margin + boxWidth + 4;

    // Draw sender box
    doc.setLineWidth(0.2);
    doc.rect(leftBoxX, yPosition, boxWidth, boxHeight);

    // Draw beneficiary box
    doc.rect(rightBoxX, yPosition, boxWidth, boxHeight);

    // Sender section content
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.text(intl ? intl.formatMessage({ id: 'settlement_SenderOurCompany' }) : 'Sender (Our Company)', leftBoxX + 3, yPosition + 6);
    yPosition += 2;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_Organisation' }) : 'Organisation'}:`, leftBoxX + 3, yPosition + 11);
    doc.setFont('helvetica', 'normal');
    doc.text(`${settlementData.sender}`, leftBoxX + 35, yPosition + 11);
    doc.setFont('helvetica', 'bold');
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_Bank' }) : 'Bank'}:`, leftBoxX + 3, yPosition + 16);
    doc.setFont('helvetica', 'normal');
    doc.text(`${settlementData.senderBankName || '-'}`, leftBoxX + 35, yPosition + 16);
    doc.setFont('helvetica', 'bold');
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_BankAccount' }) : 'Bank Account'}:`, leftBoxX + 3, yPosition + 21);
    doc.setFont('helvetica', 'normal');
    doc.text(`${settlementData.senderBank}`, leftBoxX + 35, yPosition + 21);

    yPosition += -1;
    // Beneficiary section content
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.text(intl ? intl.formatMessage({ id: 'settlement_BeneficiaryPTO' }) : 'Beneficiary (PTO)', rightBoxX + 3, yPosition + 6);
    yPosition += 2;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_Organisation' }) : 'Organisation'}:`, rightBoxX + 3, yPosition + 11);
    doc.setFont('helvetica', 'normal');
    doc.text(`${settlementData.beneficiary}`, rightBoxX + 35, yPosition + 11);
    doc.setFont('helvetica', 'bold');
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_Bank' }) : 'Bank'}:`, rightBoxX + 3, yPosition + 16);
    doc.setFont('helvetica', 'normal');
    doc.text(`${settlementData.beneficiaryBankName || '-'}`, rightBoxX + 35, yPosition + 16);
    doc.setFont('helvetica', 'bold');
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_BankAccount' }) : 'Bank Account'}:`, rightBoxX + 3, yPosition + 21);
    doc.setFont('helvetica', 'normal');
    doc.text(`${settlementData.beneficiaryBank}`, rightBoxX + 35, yPosition + 21);

    yPosition += boxHeight + 0;

    // Amount & Currency Section - Boxed
    const amountBoxHeight = 8;
    doc.rect(margin, yPosition, contentWidth, amountBoxHeight);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    const amountLabel = `${intl ? intl.formatMessage({ id: 'settlement_AmountToSettleLabel' }) : 'Amount to Settle'}:`;
    const amountValue = `${formatAmount2(settlementData.amount)} ${settlementData.currency === 'EGP' ? (intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP') : (settlementData.currency || 'EGP')}`;

    doc.text(amountLabel, margin + 3, yPosition + 5.5);
    doc.text(amountValue, pageWidth - margin - 3, yPosition + 5.5, { align: 'right' });

    yPosition += amountBoxHeight + 8;

    // Check if we need a new page
    if (yPosition > 200) {
      doc.addPage();
      yPosition = 20;
    }

    // Sender Journal Entries
    if (settlementData.senderJournalEntries && settlementData.senderJournalEntries.length > 0) {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.text(intl ? intl.formatMessage({ id: 'settlement_SuggestedERPJournalEntrySenderTitle' }) : 'Suggested ERP Journal Entry (Sender)', margin, yPosition);
      yPosition += 4;

      // Prepare table data
      const senderTableData = settlementData.senderJournalEntries.map(entry => [
        getAccountName(entry.account),
        entry.debit ? `${formatAmount5(entry.debit)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}` : '-',
        entry.credit ? `${formatAmount5(entry.credit)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}` : '-',
        entry.description
      ]);

      // Add totals row
      const senderDebitTotal = settlementData.senderJournalEntries.reduce((sum, entry) => sum + (entry.debit || 0), 0);
      const senderCreditTotal = settlementData.senderJournalEntries.reduce((sum, entry) => sum + (entry.credit || 0), 0);
      senderTableData.push([
        intl ? intl.formatMessage({ id: 'settlement_Total' }) : 'Total',
        `${formatAmount5(senderDebitTotal)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}`,
        `${formatAmount5(senderCreditTotal)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}`,
        ''
      ]);

      autoTable(doc, {
        startY: yPosition,
        head: [[
          intl ? intl.formatMessage({ id: 'settlement_Account' }) : 'Account',
          intl ? intl.formatMessage({ id: 'settlement_Debit' }) : 'Debit',
          intl ? intl.formatMessage({ id: 'settlement_Credit' }) : 'Credit',
          intl ? intl.formatMessage({ id: 'settlement_DescriptionLabel' }) : 'Description'
        ]],
        body: senderTableData,
        margin: { left: margin, right: margin },
        styles: {
          fontSize: 8,
          cellPadding: 2,
          lineColor: [0, 0, 0],
          lineWidth: 0.1
        },
        headStyles: {
          fillColor: [250, 250, 250],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          lineColor: [0, 0, 0],
          lineWidth: 0.1
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [255, 255, 255]
        },
        columnStyles: {
          1: { halign: 'right' },
          2: { halign: 'right' }
        }
      });

      yPosition = doc.lastAutoTable.finalY + 10;
    }

    // Check if we need a new page
    if (yPosition > 200) {
      doc.addPage();
      yPosition = 20;
    }

    // Beneficiary Journal Entries
    if (settlementData.beneficiaryJournalEntries && settlementData.beneficiaryJournalEntries.length > 0) {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.text(intl ? intl.formatMessage({ id: 'settlement_SuggestedERPJournalEntryBeneficiaryTitle' }) : 'Suggested ERP Journal Entry (Beneficiary)', margin, yPosition);
      yPosition += 4;

      // Prepare table data
      const beneficiaryTableData = settlementData.beneficiaryJournalEntries.map(entry => [
        getAccountName(entry.account),
        entry.debit ? `${formatAmount5(entry.debit)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}` : '-',
        entry.credit ? `${formatAmount5(entry.credit)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}` : '-',
        entry.description
      ]);

      // Add totals row
      const beneficiaryDebitTotal = settlementData.beneficiaryJournalEntries.reduce((sum, entry) => sum + (entry.debit || 0), 0);
      const beneficiaryCreditTotal = settlementData.beneficiaryJournalEntries.reduce((sum, entry) => sum + (entry.credit || 0), 0);
      beneficiaryTableData.push([
        intl ? intl.formatMessage({ id: 'settlement_Total' }) : 'Total',
        `${formatAmount5(beneficiaryDebitTotal)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}`,
        `${formatAmount5(beneficiaryCreditTotal)} ${intl ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : 'EGP'}`,
        ''
      ]);

      autoTable(doc, {
        startY: yPosition,
        head: [[
          intl ? intl.formatMessage({ id: 'settlement_Account' }) : 'Account',
          intl ? intl.formatMessage({ id: 'settlement_Debit' }) : 'Debit',
          intl ? intl.formatMessage({ id: 'settlement_Credit' }) : 'Credit',
          intl ? intl.formatMessage({ id: 'settlement_DescriptionLabel' }) : 'Description'
        ]],
        body: beneficiaryTableData,
        margin: { left: margin, right: margin },
        styles: {
          fontSize: 8,
          cellPadding: 2,
          lineColor: [0, 0, 0],
          lineWidth: 0.1
        },
        headStyles: {
          fillColor: [250, 250, 250],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          lineColor: [0, 0, 0],
          lineWidth: 0.1
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [255, 255, 255]
        },
        columnStyles: {
          1: { halign: 'right' },
          2: { halign: 'right' }
        }
      });

      yPosition = doc.lastAutoTable.finalY + 4;
    }

    // Check if we need a new page
    if (yPosition > 220) {
      doc.addPage();
      yPosition = 20;
    }

    // Bank Transfer Details - Boxed
    const bankDetailsBoxHeight = 22;
    doc.rect(margin, yPosition, contentWidth, bankDetailsBoxHeight);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text(intl ? intl.formatMessage({ id: 'settlement_BankTransferDetails' }) : 'Bank Transfer Details', margin + 3, yPosition + 6);
    yPosition += 1;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);

    if (settlementData.bank_ref_no || settlementData.bank_description || settlementData.bank_transfer_date) {
      doc.setFont('helvetica', 'bold');
      doc.text(`${intl ? intl.formatMessage({ id: 'settlement_ACHReferenceNumber' }) : 'ACH Reference No.'}`, margin + 3, yPosition + 10);
      doc.setFont('helvetica', 'normal');
      doc.text(` ${settlementData.bank_ref_no || '-'}`, margin + 45, yPosition + 10);

      doc.setFont('helvetica', 'bold');
      doc.text(`${intl ? intl.formatMessage({ id: 'settlement_Description' }) : 'Description'}`, margin + 3, yPosition + 14);
      doc.setFont('helvetica', 'normal');
      doc.text(`${settlementData.bank_description || '-'}`, margin + 45, yPosition + 14);


      doc.setFont('helvetica', 'bold');
      doc.text(`${intl ? intl.formatMessage({ id: 'settlement_TransferDateLabel' }) : 'Transfer Date'}`, margin + 3, yPosition + 18);
      doc.setFont('helvetica', 'normal');
      doc.text(`${formatDate(settlementData.bank_transfer_date)}`, margin + 45, yPosition + 18);


    } else {
      doc.setFont('helvetica', 'bold');
      doc.text(intl ? intl.formatMessage({ id: 'settlement_NoBankTransferDetailsEntered' }) : 'No bank transfer details entered yet', margin + 3, yPosition + 12);
    }

    yPosition += bankDetailsBoxHeight + 4;

    // Bank Transfer Notes - Boxed
    const notesBoxHeight = 15;
    doc.rect(margin, yPosition, contentWidth, notesBoxHeight);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text(intl ? intl.formatMessage({ id: 'settlement_BankTransferNotes' }) : 'Bank Transfer Notes', margin + 3, yPosition + 6);
    yPosition += 1;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    if (settlementData.notes) {
      // Split long notes into multiple lines but keep within box
      const splitNotes = doc.splitTextToSize(settlementData.notes, contentWidth - 10);
      const maxLines = 2; // Limit to fit in box
      const notesToShow = splitNotes.slice(0, maxLines);
      doc.text(notesToShow, margin + 3, yPosition + 10);
    } else {
      doc.setFont('helvetica', 'bold');
      doc.text(intl ? intl.formatMessage({ id: 'settlement_NoAdditionalNotes' }) : 'No additional notes', margin + 3, yPosition + 10);
    }

    yPosition += notesBoxHeight + 4;



    // Signature Section - Two boxes
    const signatureBoxHeight = 23;
    const signatureBoxWidth = (contentWidth - 10) / 2; // 10mm gap between boxes
    const leftSigBoxX = margin;
    const rightSigBoxX = margin + signatureBoxWidth + 10;

    // Draw signature boxes
    doc.setLineWidth(0.2);
    doc.rect(leftSigBoxX, yPosition, signatureBoxWidth, signatureBoxHeight);
    doc.rect(rightSigBoxX, yPosition, signatureBoxWidth, signatureBoxHeight);

    // Finance Manager signature
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text(intl ? intl.formatMessage({ id: 'settlement_FinanceManager' }) : 'Finance Manager', leftSigBoxX + 3, yPosition + 6);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_NameLabel' }) : 'Name'}: _______________`, leftSigBoxX + 3, yPosition + 10);
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_DateLabel' }) : 'Date'}: _______________`, leftSigBoxX + 3, yPosition + 14);
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_Signature' }) : 'Signature'}: ___________`, leftSigBoxX + 3, yPosition + 18);

    // General Manager signature
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text(intl ? intl.formatMessage({ id: 'settlement_GeneralManager' }) : 'General Manager', rightSigBoxX + 3, yPosition + 6);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_NameLabel' }) : 'Name'}: _______________`, rightSigBoxX + 3, yPosition + 10);
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_DateLabel' }) : 'Date'}: _______________`, rightSigBoxX + 3, yPosition + 14);
    doc.text(`${intl ? intl.formatMessage({ id: 'settlement_Signature' }) : 'Signature'}: ___________`, rightSigBoxX + 3, yPosition + 18);

    yPosition += signatureBoxHeight + 10;

    // Footer
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    const footerText = `${intl ? intl.formatMessage({ id: 'settlement_AFCSettlementSystem' }) : 'AFC Settlement System'} | ${intl ? intl.formatMessage({ id: 'settlement_GeneratedOn' }) : 'Generated on'} ${formatDate(new Date().toISOString())}`;
    doc.text(footerText, pageWidth / 2, yPosition, { align: 'center' });

    // Save the PDF
    doc.save(`settlement-${settlementData.id}-text.pdf`);

    return Promise.resolve();

  } catch (error) {
    console.error('Error generating text-based PDF:', error);
    throw error;
  }
};

// Also export as default for compatibility
export default generateSettlementTextPDF;
